import { _defineProperty } from "./index13.js";
import { DecompressRgObject } from "./index200.js";
import { frameToSite } from "./index232.js";
import { initThree } from "./index233.js";
import { RG_TYPE } from "@project-rouge/rg-core";
import { getAbstractMeshProps, getRgObjectsOfType as getRgObjectsOfType$1, updateAbstractSiteInstaMesh } from "@project-rouge/rg-three";
import { BoxGeometry, BufferGeometry, DynamicDrawUsage, Float32BufferAttribute, InstancedMesh, Line, LineBasicMaterial, MeshLambertMaterial, OrthographicCamera, Vector3 } from "three";
import { dispose } from "@react-three/fiber";
import { expose } from "comlink";
var lineMat = new LineBasicMaterial({
	color: 65348,
	linewidth: 1,
	depthTest: false
});
var ThreeAbstractSiteWorker = class {
	constructor(width = 50, height = 50) {
		_defineProperty(this, "renderer", void 0);
		_defineProperty(this, "camera", void 0);
		_defineProperty(this, "orthoCam", void 0);
		_defineProperty(this, "scene", void 0);
		_defineProperty(this, "mesh", void 0);
		_defineProperty(this, "plots", []);
		_defineProperty(this, "canvas", void 0);
		_defineProperty(this, "ready", false);
		this.canvas = new OffscreenCanvas(width, height);
		const { renderer, camera, scene } = initThree({
			canvas: this.canvas,
			addLights: true
		});
		this.orthoCam = new OrthographicCamera();
		Object.assign(this.canvas, { style: {} });
		this.renderer = renderer;
		this.camera = camera;
		this.scene = scene;
		this.ready = true;
	}
	async render(props) {
		const camera = props.orthographic ? this.orthoCam : this.camera;
		if (this.mesh) {
			this.mesh.removeFromParent();
			dispose(this.mesh);
		}
		if (this.plots.length) {
			this.plots.forEach((p) => p.removeFromParent());
			this.plots.forEach((p) => dispose(p));
			this.plots.length = 0;
		}
		resizeThree({
			renderer: this.renderer,
			width: props.width,
			height: props.height,
			camera
		});
		const obj = props.obj instanceof Uint8Array ? DecompressRgObject(props.obj) : props.obj;
		const { matrices, colors } = getAbstractMeshProps({ obj });
		this.mesh = new InstancedMesh(new BoxGeometry(1, 1, 1), new MeshLambertMaterial({ color: "#fff" }), matrices.length);
		this.mesh.instanceMatrix.setUsage(DynamicDrawUsage);
		updateAbstractSiteInstaMesh({
			mesh: this.mesh,
			matrices,
			colors
		});
		frameToSite({
			obj,
			camera,
			canvas: this.canvas,
			direction: new Vector3().fromArray(props.camDir)
		});
		if (props.plots !== void 0) {
			this.plots = getRgObjectsOfType$1(obj, RG_TYPE.Plot).map((plot) => {
				const geo = new BufferGeometry();
				geo.setAttribute("position", new Float32BufferAttribute(plot.data.polygon.flat(), 3));
				lineMat.color.set(props.plots);
				const line = new Line(geo, lineMat);
				line.renderOrder = 1;
				return line;
			});
			this.scene.add(...this.plots);
		}
		this.scene.add(this.mesh);
		this.renderer.render(this.scene, camera);
		return this.canvas.convertToBlob();
	}
	isReady() {
		return this.ready;
	}
};
expose(new ThreeAbstractSiteWorker());
function resizeThree({ renderer, width, height, camera }) {
	renderer.setSize(width, height, false);
	if (camera instanceof OrthographicCamera) {
		camera.left = -width * .5;
		camera.right = width * .5;
		camera.top = height * .5;
		camera.bottom = -height * .5;
	} else camera.aspect = width / height;
	camera.matrixWorldNeedsUpdate = true;
	camera.updateProjectionMatrix();
}
export { ThreeAbstractSiteWorker };

//# sourceMappingURL=index234.js.map